export default "__VITE_PUBLIC_ASSET__3075d485__"